<div *ngIf="loading; else elseBlock" class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>

  <ng-template #elseBlock >

    <div style="display: flex;justify-content: space-between;flex-direction: column;height: 100%;">
      <h2>Asignar Productos a {{data.data.nombre}}</h2>

      <mat-form-field appearance="outline" style="width: 100%;font-size: 14px">
        <mat-label>Filtrar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda"/>
      </mat-form-field>

    <div class="mat-elevation-z8">
      <mat-table [dataSource]="dataSource" matSort >

        <ng-container matColumnDef="Check">

          <mat-header-cell  *matHeaderCellDef></mat-header-cell>
          <mat-cell  *matCellDef="let element"><mat-checkbox [checked]="element.checked" (change)="updateCheck(element)">
          </mat-checkbox></mat-cell>
        </ng-container>

        <ng-container matColumnDef="nombre">
          <mat-header-cell  *matHeaderCellDef>Nombre</mat-header-cell>
          <mat-cell  *matCellDef="let element">{{ element?.nombre }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="categoria">
          <mat-header-cell  *matHeaderCellDef>Categoría</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.categoriaProducto }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="tipo">
          <mat-header-cell  *matHeaderCellDef>Tipo</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.tipoProducto }}</mat-cell>
        </ng-container>

        <mat-header-row  *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row  *matRowDef="let row; columns: displayedColumns"></mat-row>

      </mat-table>
    </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

    <div style="display: flex;justify-content: center">
      <button mat-raised-button class="buttonPrimary" (click)="closeDialog()">Confirmar</button>
    </div>
    </div>
    
  </ng-template>
